import { useEffect } from 'react'

/**
 * Haelt den Bildschirm waehrend der Runde an (WETTBANDIT-69).
 *
 * Die Kundin fragte, ob die App die Bildschirmsperre verhindern kann. Browser
 * koennen das seit der Screen-Wake-Lock-Schnittstelle - ohne Installation und
 * ohne App-Store. Wo es sie nicht gibt (aeltere Geraete, Safari vor 16.4),
 * passiert nichts: Die Sperre bleibt wie bisher, der Rest laeuft weiter.
 *
 * Die Sperre faellt beim Wechsel in einen anderen Tab weg und wird deshalb bei
 * der Rueckkehr neu angefordert.
 */
export function useWakeLock(active: boolean): void {
    useEffect(() => {
        if (!active || !('wakeLock' in navigator)) {
            return
        }

        let sentinel: WakeLockSentinel | null = null
        let cancelled = false

        const request = async () => {
            try {
                sentinel = await navigator.wakeLock.request('screen')
            } catch {
                // Verweigert der Browser die Sperre (etwa bei wenig Akku),
                // bleibt es beim normalen Verhalten.
            }
        }

        const onVisibility = () => {
            if (document.visibilityState === 'visible' && !cancelled) {
                void request()
            }
        }

        void request()
        document.addEventListener('visibilitychange', onVisibility)

        return () => {
            cancelled = true
            document.removeEventListener('visibilitychange', onVisibility)
            void sentinel?.release()
        }
    }, [active])
}
